import { Text } from '@profitowi/component-library';
import React, { ReactNode } from 'react';

import { Client } from 'types/client';

type Props = {
  client: Client;
  generateAddressInfo: () => ReactNode;
};

function CompanyDetails({ client, generateAddressInfo }: Props) {
  return (
    <div className="flex-col space-y-4 ">
      <div className="flex justify-center space-x-4">
        <Text weight="bold">Nazwa:</Text>
        <Text>{client?.personalData.name ? client?.personalData.name : '-'}</Text>
      </div>
      <div className="flex justify-center space-x-4">
        <Text weight="bold">NIP:</Text>
        <Text>{client?.personalData.nip ? client?.personalData.nip : '-'}</Text>
      </div>
      <div className="flex justify-center space-x-4">
        <Text weight="bold">Adres:</Text>
        <Text>{generateAddressInfo()}</Text>
      </div>
      <div className="flex justify-center space-x-4">
        <Text weight="bold">Osoba kontaktowa:</Text>
        <Text>
          {client.personalData.firstName || client.personalData.lastName ? (
            <>
              {client?.personalData.firstName} {client?.personalData.lastName}
            </>
          ) : (
            <>-</>
          )}
        </Text>
      </div>
    </div>
  );
}

export default CompanyDetails;
